angular
	.module 'App.Repository'
	.factory 'TicketTypeRepository', ['BaseRepository', (BaseRepository) ->
		class TicketTypeRepository extends BaseRepository
			@resource = '/ticket_types'
			@isRestricted = true

		return new TicketTypeRepository
	]
